var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"panel",class:['tab-pane', { 'active fade': _vm.active, in: _vm.fadein }],attrs:{"role":"tabpanel"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }